export const getRoleNotificationConfigs = (state) => state.notificationConfig.configs;
export const getUserNotificationConfigs = (state) => state.notificationConfig.userConfigs;
export const getCopiedSettings = (state) => state.notificationConfig.copiedSettings;
